import { Drawer } from 'antd'
import styled from 'styled-components'

/**
 * Represents a basic styled version of the antd Drawer component.
 *
 * @class
 * @extends Drawer
 *
 */
const BasicDrawer = styled(Drawer)`
  --ant-font-size-lg: 20px;

  .ant-drawer-header {
    padding: 30px 30px 0;
    border: none;
  }

  .ant-drawer-body {
    padding: 20px 30px;
  }

  .ant-drawer-footer {
    padding: 20px 30px;
  }
`

export default BasicDrawer
